import { tUserProviderProps } from './User.types';
import { UserContext } from './User.context';

import useUser from './User.hook';

export default function SessionProvider(props: tUserProviderProps) {
  const { children } = props;
  const user = useUser();

  return <UserContext.Provider value={user}>{children}</UserContext.Provider>;
}
